<template>
  <div>
    <card-box>
      <card-title class="mb-3">
        Export Facebook Catalog Feed
      </card-title>
      <div class="form-group">
        <label for="brand_name">Filter</label>
        <input
          id="filter"
          v-model="keyword"
          type="text"
          class="form-control"
          placeholder="Filter product name or tag"
        >

        <small class="form-text text-muted">Leave blank for all products</small>
      </div>
      <div class="form-group">
        <label for="style">Style</label>
        <select
          id="style"
          v-model="style"
          class="form-control"
          required="required"
        >
          <option
            v-for="item in design.styles"
            :key="item.name"
            :value="item.name"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="brand_name">Brand Name <em class="text-danger">*</em></label>
        <input
          id="brand_name"
          v-model="brand"
          name="brand_name"
          required="required"
          type="text"
          class="form-control"
        >
        <small class="form-text text-muted">You can use your domain name</small>
      </div>
      <div class="form-group">
        <label for="brand_name">Product Type</label>
        <input
          id="product_type"
          v-model="product_type"
          name="produc_type"
          required="required"
          type="text"
          class="form-control"
        >
        <small class="form-text text-muted">Ex. T Shirt or Hoodie or Phone Case...</small>
      </div>
      <!--  <div class="form-group">
                  <label for="description">Description</label>
                  <textarea v-model="bullet_points" v-on:keyup.enter="input_bullet" id="bullet_points"
                            name="bullet_points" class="form-control"></textarea>
                  <small class="form-text text-muted">Only alphanumeric characters (A-Z and 0-9) are recommended.</small>
              </div>-->
      <div class="form-group">
        <label for="description">Description <em class="text-danger">*</em></label>
        <textarea
          id="description"
          v-model="description"
          required
          name="description"
          class="form-control"
        />
        <small class="form-text text-muted">Only alphanumeric characters (A-Z and 0-9) are recommended.</small>
      </div>
      <div class="form-group">
        <label for="country">Country</label>
        <select
          id="country"
          v-model="country"
          required
          class="form-control"
        >
          <option value="US">
            United States
          </option>
        </select>
      </div>
      <div class="form-group">
        <button
          class="btn btn-primary"
          @click="exportFeed()"
        >
          Export
        </button>
      </div>
    </card-box>
  </div>
</template>

<script>
    import CardBox from "./CardBox";
    import CardTitle from "./CardTitle";

    export default {
        name: "FacebookCatalog",
        components: {CardTitle, CardBox},
        data: function () {
            return {
                bullet_points: '',
                keyword: '',
                description: '',
                product_type:'T Shirt',
                country: 'US',
                brand: '',
                style: 'Guys Tee',
                design: {},
                export_status: false
            }
        },
        mounted() {
            this.loadDesign()
            this.brand = this.$author.brand()
            if (this.bullet_points == '') {
                this.bullet_points += '• ';
            }
        },

        methods: {
            inputBullet: function () {
                this.bullet_points += '• ';
            },
            exportFeed: function () {
                let vm = this

                if ( this.export_status ) return false

                if (this.description == '') {
                    this.$swal('Please enter description')
                    return false
                }

                if (this.brand == '') {
                    this.$swal('Please enter your brand name')
                    return false
                }
                this.export_status = true


                let post = {
                    keyword: this.keyword,
                    description: this.description,
                    country: this.country,
                    brand: this.brand,
                    style: this.style
                }
                this.$http.post(this.$config.api + 'marketing/google', post).then(function (res) {
                    vm.$helper.downloadCsv('google_feed.csv', res.data)
                    vm.export_status = false
                });
            },
            loadDesign: function () {
                let vm = this
                this.$http.get(this.$config.api + 'design').then(function (res) {
                    vm.design = res.data

                });
            },

        }


    }
</script>

<style scoped>

</style>